import { config, handleResponse } from '../../_helpers';

export const vesselService = {
    getAllVessels,
    getVesselById,
    createVessel,
    updateVessel,
    deleteVessel,
    activation,
    getIsActive,
    createVesselStructure,
    updateVesselStructure,
    deleteVesselStructure,
    getVesselStowageTemplate,
    getVesselStowageTemplateByCode,
    createVesselStowageTemplate,
    updateVesselStowageTemplate,
    deleteVesselStowageTemplate,
    getVesselForVesselChange,
    getProCenterIdFromBase,
};

function getAllVessels(skip, take, filter, search) {
    const requestOptions = {
        method: 'GET'
    };
    if (filter && search) {
        return fetch(`${config.apiUrl}/Vessels/load?skip=${skip}&take=${take}&filter=${filter}&search=${search}`, requestOptions).then(handleResponse);
    } else {
        return fetch(`${config.apiUrl}/Vessels/load?skip=${skip}&take=${take}`, requestOptions).then(handleResponse);
    }
}
function getVesselById(code) {
    const requestOptions = {
        method: 'GET'
    };
    return fetch(`${config.apiUrl}/Vessels/get/${code}`, requestOptions).then(handleResponse);
}
function createVessel(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/Vessels`, requestOptions).then(handleResponse);
}
function updateVessel(payload, code) {
    const requestOptions = {
        method: 'PUT',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/Vessels/update/${code}`, requestOptions).then(handleResponse);
}
function deleteVessel(id) {
    const requestOptions = {
        method: 'DELETE',
        body: JSON.stringify(id),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/Vessels/delete`, requestOptions).then(handleResponse);
}
function activation(id, isActive) {
    const requestOptions = {
        method: 'PUT'
    };
    return fetch(`${config.apiUrl}/Vessels/activate/${id}?isActive=${isActive}`, requestOptions).then(handleResponse);
}
function getIsActive() {
    const requestOptions = {
        method: 'GET'
    };
    return fetch(`${config.apiUrl}/Vessels/getIsActive`, requestOptions).then(handleResponse);
}

function createVesselStructure(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/Vessels/CreateVesselStowagePlan`, requestOptions).then(handleResponse);
}
function updateVesselStructure(payload, code) {
    const requestOptions = {
        method: 'PUT',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/Vessels/updateStowagePlan/${code}`, requestOptions).then(handleResponse);
}
function deleteVesselStructure(id) {
    const requestOptions = {
        method: 'DELETE',
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/Vessels/deleteStowagePlan/${id}`, requestOptions).then(handleResponse);
}
function getVesselStowageTemplate() {
    const requestOptions = {
        method: 'GET'
    };
    return fetch(`${config.apiUrl}/Vessels/getListStowageTemplate`, requestOptions).then(handleResponse);
}
function getVesselStowageTemplateByCode(code) {
    const requestOptions = {
        method: 'GET'
    };
    return fetch(`${config.apiUrl}/Vessels/getStowageTemplate/${code}`, requestOptions).then(handleResponse);
}
function createVesselStowageTemplate(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/Vessels/CreateVesselStowagePlanTemplate`, requestOptions).then(handleResponse);
}
function updateVesselStowageTemplate(payload, code) {
    const requestOptions = {
        method: 'PUT',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/Vessels/updateStowageTemplate/${code}`, requestOptions).then(handleResponse);
}
function deleteVesselStowageTemplate(id) {
    const requestOptions = {
        method: 'DELETE',
        body: JSON.stringify(id),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/Vessels/deleteStowageTemplate`, requestOptions).then(handleResponse);
}
function getVesselForVesselChange() {
    const requestOptions = {
        method: 'GET'
    };
    return fetch(`${config.apiUrl}/Vessels/getVesselForVesselChange`, requestOptions).then(handleResponse);
}
function getProCenterIdFromBase(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/Vessels/getProfitCenterFromBase`, requestOptions).then(handleResponse);
}